function mhReplace(){
    $('.product').each(function(){
        if($(this).find('.availability').length){
            $(this).find('.prices').after($(this).find('.availability'))
        }
        if($(this).find('.widget-parameter-list').length){
            $(this).find('.p-in-in').append($(this).find('.widget-parameter-wrapper'))
            $(this).find('.widget-parameter-list li a').each(function(){
                var liText = $(this).text().trim();
                if(customColors[liText]) {
                    $(this).attr('style', 'background-color:' + customColors[liText]);
                }
            })
            
        }
        else{
            $(this).find('.p-in-in').append('<div class="widgetNo"></div>')
        }
        
       
    })
}


$(document).ready(function() {
    mhReplace()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhReplace()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhReplace();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhReplace();
});